import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'AdminUser',
    column_type: 'id',
  },
  created_at: {
    model_name: 'AdminUser',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'AdminUser',
    column_type: 'datetime',
  },
  email: {
    model_name: 'AdminUser',
    column_type: 'string',
  },
  name: {
    model_name: 'AdminUser',
    column_type: 'string',
  },
  is_block: {
    model_name: 'AdminUser',
    column_type: 'boolean',
  },
  admin_users_roles_attributes: {
    model_name: 'AdminUser',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
